import { Building2 } from 'lucide-react';

// Evidenza "è un IP pubblico del cliente" (tenant_public_ips): verde, con la sede del tenant a
// cui l'IP appartiene (o l'etichetta, se non c'è una sede) e il resto nel tooltip. Usata in
// Security Alerts, Security Incidents e nei dettagli di alert e incident.
export default function CustomerIpBadge({ label, siteName, compact }: { label: string | null; siteName?: string | null; compact?: boolean }) {
  const detail = [siteName, label].filter(Boolean).join(' — ');
  const text = compact || !detail ? 'Customer IP' : `Customer · ${siteName || label}`;
  return (
    <span className="badge bg-emerald-100 text-emerald-800 inline-flex items-center gap-1 whitespace-nowrap"
      title={`Public IP of the customer${detail ? `: ${detail}` : ''}`}>
      <Building2 size={11} /> {text}
    </span>
  );
}
